import React from 'react'
import PropTypes from 'prop-types'

import {
  TextField,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core'

const EMPTY_ORG = {
  id: 0,
  name: '',
}

class OrganizationFormDialog extends React.Component {
  static propTypes = {
    organization: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
  }

  state = EMPTY_ORG

  componentDidMount() {
    const { organization } = this.props

    if (Object.keys(organization).length) {
      this.setState({ ...organization })
    } else {
      this.setState(EMPTY_ORG)
    }
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.currentTarget.value,
    })
  }

  handleSubmit = () => {
    this.props.onSubmit(this.state)
    this.props.onClose()
  }

  getDialogTitle = () => {
    if (this.props.organization.id) {
      return `Edit Organization ${this.props.organization.id}`
    }

    return 'Add Organization'
  }

  render() {
    return (
      <Dialog
        open
        onClose={this.props.onClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">{ this.getDialogTitle() }</DialogTitle>
        <DialogContent>
          <TextField
            label="Organization Name"
            name="name"
            onChange={this.handleChange}
            required
            value={this.state.name}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.onClose} variant="contained" color="secondary">
            Cancel
          </Button>
          <Button onClick={this.handleSubmit} variant="contained" color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default OrganizationFormDialog
